import { inject, Injectable } from '@angular/core';
import { INotificationMessageConfig } from '@app/account/notification-preferences/interfaces/interface';
import { NotificationPreferencesConfigService } from '@app/account/notification-preferences/services/notification-preferences-config.service';
import { INotificationMessage } from '@app/account/notifications-and-alerts/interface';
import { ChannelNotification } from '@app/generated/graphql';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  // dependencies
  private _notificationPreferencesConfigService = inject(
    NotificationPreferencesConfigService,
  );

  // streams
  private _notificationSubject = new Subject<INotificationMessage[]>();

  notifications$ = this._notificationSubject.asObservable();

  /**
   * Transforms backend channel notifications into UI notification messages.
   * Title/body come from NotificationPreferencesConfigService.getResolvedChannelNotificationCopy.
   */
  public transformChannelNotificationsToNotificationMessages(
    notifications: ChannelNotification[],
  ): INotificationMessage[] {
    return notifications.map((notification: ChannelNotification) => {
      const entry: INotificationMessageConfig | undefined =
        this._notificationPreferencesConfigService.getNotificationMessageConfig(
          notification?.notificationRule?.notificationSlug,
        );

      if (!entry) {
        return null;
      }

      const copy =
        this._notificationPreferencesConfigService.getResolvedChannelNotificationCopy(
          notification,
        );

      return {
        id: notification.id,
        metadata: notification.channelMetadata,
        notificationRuleSlug: notification?.notificationRule?.notificationSlug,
        displayTitle: copy.title,
        displayDescription: copy.body,
        severity: notification?.notificationRule?.severity,
        life: entry?.life,
        actionLabel: entry?.actionLabel,
        action: entry?.action,
        channelNotification: notification,
      };
    });
  }

  showNotifications(notifications: INotificationMessage[]): void {
    if (!notifications?.length) {
      return;
    }

    this._notificationSubject.next(notifications);
  }
}
